

















































































































































































































































































import baseUrl from '@/utils/envConfig'
import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import qs from 'qs'

import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString,
  downFile
} from '@/utils/tool'
import { getCookie } from '@/utils/cookies'
import { getVIPOrderList, getPayTypeMap, getPayStatusMap, getGoodsTypeMap, addVIP } from '@/api/trade/trade'
import axios from 'axios'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

interface item {
  id: number | string
  name: string
}

const payTypeList = [
  {
    'id': 'mobilealipayweb',
    'name': 'mobilealipayweb'
  },
  {
    'id': 'paymentallwap',
    'name': 'paymentallwap'
  },
  {
    'id': 'paypal',
    'name': 'paypal'
  },
  {
    'id': 'payssionwap',
    'name': 'payssionwap'
  },
  {
    'id': 'stripe',
    'name': 'stripe'
  },
  {
    'id': 'unknow',
    'name': 'unknow'
  }
]
const statusList = [
  {
    'id': 'new',
    'name': 'new'
  },
  {
    'id': 'finish',
    'name': 'finish'
  },
  {
    'id': 'faile',
    'name': 'faile'
  },
  {
    'id': 'delete',
    'name': 'delete'
  }
]
const goodsTypeList = [
  {
    'id': 1,
    'name': '永久'
  },
  {
    'id': 0,
    'name': '其他'
  }
]

@Component({
  name: 'TradeVip'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    udid: '',
    payType: '',
    status: '',
    transactionNo: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private formParams = {
    udid: '',
    goodsType: '',
    days: 0
  }
  private tableHeight: number = 500
  // component data
  payTypeList: item[] = payTypeList
  statusList: item[] = statusList
  goodsTypeList: item[] = goodsTypeList
  dateArrayExpire = ['', '']
  dateArrayPay = ['', '']
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount = 0
  formVisible = false
  rules: any = {
    udid: [{ required: true, message: '请填写UDID', trigger: 'blur' }],
    goodsType: [{ required: true, message: '请选择类别', trigger: 'change' }],
    days: [{ required: true, message: '请输入天数', trigger: 'blur' }]
  }
  // lifecycle
  async created() {
    this.getTableData()
    // let goodType = await getGoodsTypeMap()
    // console.log(goodType)
    // this.getAccountStatus()
    // this.getAreaList()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getVIPOrderList(this.params)
    this.tableData = res.data.dataList
    this.totalCount = res.data.pageInfo.totalCount
    this.tableLoading = false
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  handleDateChangePay(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  setParams(params: any) {
    let arr = []
    let ignoreList: string[] = ['page', 'pageCount']
    for (let key in params) {
      if (!ignoreList.includes(key)) {
        arr.push(key + '=' + params[key])
      }
    }
    return arr.join('&')
  }

  handleExcel() {
    const that = this
    let xhr = new XMLHttpRequest()
    let p: any = { ...that.params }
    p.pageCount = 300
    let url = baseUrl + '/transact/export_vip_order?' + decodeURIComponent(qs.stringify(p))
    xhr.open('GET', url, true)
    // 设置请求结果类型为blob
    xhr.responseType = 'blob'
    xhr.setRequestHeader('X-Access-Token', getCookie('token') as string)
    // 请求成功回调函数
    xhr.onload = function() {
      if (this.status === 200) {
        // 请求成功
        var blob = this.response
        // 获取blob对象地址，直接打开进行下载
        downFile(blob, '文件下载')
      } else {
        that.$message.error('导出失败!')
      }
    }
    xhr.send(null)
  }

  handleExport() {
    this.handleExcel()
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArrayPay = ['', '']
    this.dateArrayExpire = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleAdd() {
    this.formVisible = true
  }
  handleSelectionChange(list: any[]) {
    console.log(list)
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    // this.setAccount(this.selectIds)
  }
  handleRefund(item: any) {
    console.log(item)
    this.$confirm('是否确认要退款?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        // let uid = ''
        // uid = item.uid
        // let res: any = await deleteAccount({ uid })
        // if (res.status.code === 0) {
        //   this['$message'].success('删除成功!')
        //   setTimeout(() => {
        //     this.getTableData()
        //   }, 1500)
        // } else {
        //   this['$message'].error('删除失败!')
        // }
      })
      .catch(() => {})
  }
  // close dialog, clear data
  handleFormClose() {
    this.cancelForm()
  }
  cancelForm() {
    (this.$refs['formParams'] as Form).resetFields()
    this.formVisible = false
  }
  confirmForm() {
    (this.$refs['formParams'] as Form).validate(valid => {
      if (valid) {
        if (this.formParams.days <= 0) return this['$message'].warning('请填写完成后再提交!')
        // console.log(this.formParams)
        let { udid, days, goodsType } = this.formParams
        console.log({ udid, days, isPermanent: Boolean(goodsType) })
        addVIP({ udid, days, isPermanent: Boolean(goodsType) })
          .then(() => {
            this.cancelForm()
            this.getTableData()
          })
          .catch(err => err)
      } else {
        return this['$message'].warning('请填写完成后再提交!')
      }
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
